import React from 'react';
import { useRouteError } from 'react-router-dom';

import NoData from 'common/NoData';

const ErrorPage = () => {
	const error = useRouteError();
	console.error(error);

	return (
		<div id="error-page">
			<NoData customHeader={'Ooops!'} customMessage={'No such route found!'} />
		</div>
	);
};

export default ErrorPage;
